/**
 * Traduções comuns
 * Inclui: Texto de botões, mensagens de status, mensagens de erro
 */
export default {
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  purchase: 'Comprar',
  loading: 'Carregando...',
  waiting: 'Aguardando...',
  initializing: 'Inicializando...',
  refreshSuccess: 'Atualização bem-sucedida',
  copySuccess: 'Copiado',
  pricePerMin: '{price}/min',
  and: ' e ',
  youBlockedUser: 'Você bloqueou este usuário',
  youBeenBlocked: 'Você foi bloqueado por este usuário',
  days: {
    "1": "{days} dia",
    "other": "{days} dias"
  },
  busy: 'ocupado',
  // Atualização por arrastar
  pullRefresh: {
    finishedText: 'Não há mais dados',
    errorText: 'Falha ao carregar, clique para tentar novamente',
    pullingText: 'Arraste para atualizar...',
    loosingText: 'Solte para atualizar...',
  },
  // Erros relacionados a requisições
  request: {
    networkError: 'Erro de rede, verifique sua conexão',
    timeout: 'Tempo de requisição esgotado',
    serverError: 'Erro do servidor',
    unauthorized: 'Não autorizado, faça login novamente',
    forbidden: 'Acesso negado',
    notFound: 'Recurso não encontrado',
    badRequest: 'Parâmetros de requisição inválidos',
    gatewayError: 'Erro de gateway',
    serviceUnavailable: 'Serviço indisponível',
    gatewayTimeout: 'Tempo de gateway esgotado',
    requestError: 'Erro de requisição',
    tokenExpired: 'Login expirado, faça login novamente',
  },
  suspendedPopup: {
    title: 'A conta foi suspensa',
    message: 'Sua conta foi suspensa, tente novamente mais tarde',
  },
  // Signos do zodíaco
  zodiac: {
    capricornus: 'Capricórnio',
    aquarius: 'Aquário',
    pisces: 'Peixes',
    aries: 'Áries',
    taurus: 'Touro',
    gemini: 'Gêmeos',
    cancer: 'Câncer',
    leo: 'Leão',
    virgo: 'Virgem',
    libra: 'Libra',
    scorpio: 'Escorpião',
    sagittarius: 'Sagitário',
  },
  // Permissões
  permissions: {
    camera: 'Câmera',
    microphone: 'Microfone',
  },
  permissionDenied: {
    title: 'Permissão Negada',
    message: 'Não é possível usar {permissions}. Por favor, permita o acesso nas configurações do navegador',
  },
  // Erro de saldo insuficiente
  insufficientBalance: {
    title: 'Saldo Insuficiente',
    message: 'Seu saldo de diamantes é insuficiente. Recarregue ou assine o VIP para ter privilégios',
    recharge: 'Recarregar',
    vip: 'Assinar VIP',
  },
  // Status online
  onlineStatus: {
    online: 'Online',
    busy: 'Ocupado',
    active: 'Ativo',
    offline: 'Offline',
    live: 'Live',
  },
  // Nomes de conversas especiais
  specialConvName: {
    'System Notification': 'Notificação do Sistema',
    'Customer Service': 'Atendimento ao Cliente',
    'Misslive Team': 'Equipe Misslive',
    'Stranger Messages': 'Mensagens de Estranhos',
  },
  // Diálogo de aba inativa
  inactiveTab: {
    title: 'Aviso',
    message: 'O aplicativo já está aberto em outra aba. Esta aba está inativa e não pode realizar login ou outras operações. Por favor, feche as outras abas ou use a aba já aberta.',
    confirm: 'Entendi',
  },
  // Mensagens de erro
  error: {
    dbInitFailed: 'Falha na inicialização do banco de dados, tente novamente',
    loadConversationsFailed: 'Falha ao carregar conversas',
    imConnectFailed: 'Falha ao conectar ao IM',
    appInitFailed: 'Falha na inicialização do aplicativo',
  },
  // Mensagens de segurança
  security: {
    devtoolDetected: 'Ferramentas de desenvolvedor detectadas. Por privacidade e segurança dos dados do usuário, a página será redirecionada',
  },
}
